<template>
  <div class="">
    <!-- Header and Add Button -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div>
        <h2 class="text-xl font-semibold text-gray-800">List of current admin accounts</h2>
      </div>
      <button
        @click="addingNewItem"
        class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white font-semibold px-3 py-2 rounded-lg shadow transition"
      >
        <span class="material-icons text-base">add</span>
        Add Member
      </button>
    </div>
    <!-- Table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
      <table class="min-w-full bg-white rounded-xl">
        <thead class="border-b">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
            <th class="px-4 py-3"></th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Name</th>
            <th class="px-4 py-3 text-xs text-start font-semibold text-gray-500 uppercase">Email</th>
            <th class="px-4 py-3 text-xs text-start font-semibold text-gray-500 uppercase">Phone</th>
            <th class="px-4 py-3 text-xs text-start font-semibold text-gray-500 uppercase">Role</th>
            <th class="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, idx) in all"
            :key="item._id"
            class="border-b"
            :class="{ 'highlighted-account': item._id === userData._id && item.email === userData.email }"
          >
            <td class="px-4 py-1">{{ idx + 1 + (currentPage - 1) * limit }}</td>
            <td class="flex items-center gap-5">
              <vs-avatar
                v-if="item.image == '' || item.image == null"
                class="h-12 w-12 rounded-full object-cover"
                :src="require('@/assets/images/users/3.png')"
              />
              <img v-else :src="item.image" class="h-12 w-12 rounded-full object-cover ml-1" />
              <vs-icon style="cursor: pointer" icon="visibility" title="View Details" @click="viewDetails(item)"></vs-icon>
            </td>
            <td class="px-4 py-1 font-medium text-gray-800">{{ item.name }}</td>
            <td class="px-4 py-1 text-start">
              <span class="text-gray-600 text-start">{{ item.email }}</span>
            </td>
            <td class="px-4 py-1 text-start">
              <span class="text-gray-600 text-start">{{ item.phone }}</span>
            </td>
            <td class="px-4 py-1 text-start">
              <vs-chip color="success" v-if="item.isAdmin">Admin</vs-chip>
              <vs-chip color="success" v-if="!item.isAdmin">User</vs-chip>
            </td>
            <td class="px-4 py-1">
              <vs-button
                v-if="!(item._id === userData._id && item.email === userData.email)"
                style="cursor: pointer; border-radius: 100%"
                color="danger"
                icon="delete_forever"
                title="Delete Account"
                @click="deletePopup(item)"
              />
            </td>
          </tr>
          <tr v-if="!all || all.length === 0">
            <td colspan="12" class="text-center h-full py-6 text-gray-400">No accounts found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Delete Confirmation Popup -->
    <vs-popup title="Delete Account" :active.sync="deleteAccountPopup">
      <p>Are you sure you want to delete Account?</p>
      <div>
        <vs-button icon="delete_forever" class="mr-3" @click="deleteAccount">Delete Account</vs-button>
        <vs-button icon="clear" @click="deleteAccountPopup = false">Cancel</vs-button>
      </div>
    </vs-popup>
    <!-- Add Admin Popup -->
    <vs-popup title="Add new member" :active.sync="addAdmin">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <vs-input label="Name" v-model="admin.name" />
        </div>
        <div>
          <vs-input label="Email" v-model="admin.email" />
        </div>
        <div>
          <vs-input required type="number" label="Phone" v-model="admin.phone" />
        </div>
        <div>
          <vs-input type="password" label="Password" v-model="admin.password" />
        </div>
        <div class="flex-1 w-full">
          <div class="flex justify-between items-start">
            <label class="block text-sm font-semibold">Image</label>
            <button
              v-if="displayImage"
              type="button"
              color="danger"
              class="bg-red-500 p-1 h-6 rounded-md hover:bg-red-700 transition text-white"
              @click="deleteImage"
              :disabled="showLoader"
            >
              Clear
            </button>
          </div>
          <div
            class="flex flex-col items-center justify-center border-2 border-dashed rounded-md w-full h-full cursor-pointer bg-gray-50 hover:bg-gray-100 transition col-span-2"
            style="min-height: 140px; height: 100%; width: 100%"
            @dragover.prevent
            @dragenter.prevent
            @drop.prevent="onDropImage"
            @click="triggerFileInput"
          >
            <img v-if="displayImage" :src="displayImage" class="rounded-md object-cover border" style="max-width: 100%; max-height: 140px" />
            <div v-else class="flex flex-col items-center justify-center w-full h-full text-gray-400">
              <span class="material-icons" style="font-size: 32px">cloud_upload</span>
              <span>Drag & Drop or Click to Upload</span>
            </div>
            <input
              type="file"
              ref="fileInput"
              class="hidden"
              @change="onImageChange"
              accept="image/jpeg,image/jpg,image/webp"
              :disabled="showLoader"
            />
          </div>
        </div>
        <div class="md:col-span-2 pt-8 w-full">
          <vs-button color="primary" type="filled" class="flex-1 w-full" @click="btnAddAdmin">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <!-- view details popup -->
    <vs-popup :title="'Details about - ' + accName" :active.sync="viewPopup">
      <vs-row>
        <vs-col vs-lg="6" vs-xs="12" class="leftHead">
          <h4>Image</h4>
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12" class="rightHead">
          <vs-avatar v-if="accImage == ''" size="50px" :src="require('@/assets/images/users/3.png')" />
          <img v-else :src="accImage" height="50px" />
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12" class="leftHead top">
          <h4>Name</h4>
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12" class="rightHead top">
          <h5>{{ accName }}</h5>
        </vs-col>
        <hr />
        <vs-col vs-lg="6" vs-xs="12" class="leftHead top">
          <h4>Contact Email Id</h4>
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12" class="rightHead top">
          <h5>{{ accEmail }}</h5>
        </vs-col>
        <hr />
        <vs-col vs-lg="6" vs-xs="12" class="leftHead top">
          <h4>Contact Phone</h4>
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12" class="rightHead top">
          <h5>{{ accPhone }}</h5>
        </vs-col>
        <hr />
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
export default {
  name: "AdminAccounts",
  data: () => ({
    admin: {
      type: "ADMIN",
    },
    deleteAccountPopup: false,
    viewPopup: false,
    all: [],
    addAdmin: false,
    itemToDelete: {},
    accName: "",
    accEmail: "",
    accPhone: "",
    accImage: "",
    displayImage: "",
    fileName: "",
    userData: {},
    currentPage: 1,
    totalPages: 1,
    limit: 25,
    search: {
      sort: "ASC",
    },
    showLoader: false,
  }),
  methods: {
    setAppUser() {
      const user = localStorage.getItem("admin");
      if (user) {
        this.userData = {
          _id: JSON.parse(user)._id,
          email: JSON.parse(user).email,
        };
      }
    },

    async deleteAccount() {
      try {
        const r = await api.delete(`${API.DELETE_ACCOUNT}/${this.itemToDelete._id}`);
        if (r.status === 200) {
          this.$vs.notify({
            text: "Deleted Successfully",
            color: "success",
            position: "top-right",
          });
          await this.fetchAllAccounts();
        }
      } catch (err) {
        console.error(err);
        this.$vs.notify({
          text: "Already Deleted",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.deleteAccountPopup = false;
      }
    },

    async fetchAllAccounts() {
      this.$vs.loading();
      try {
        const response = await api.get(API.GET_ALL_ADMIN_ACCOUNTS);
        if (response.status === 200) {
          const allAccounts = response.data;
          const loggedInUser = allAccounts.find((account) => account._id === this.userData._id && account.email === this.userData.email);

          if (loggedInUser) this.$data.all = [loggedInUser, ...allAccounts.filter((account) => account._id !== loggedInUser._id)];
          else this.$data.all = allAccounts;
        }
      } catch (e) {
        console.error(e);
        this.$vs.notify({
          text: "Error fetching accounts",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    viewDetails(i) {
      this.$data.viewPopup = true;
      this.$data.accName = i.name;
      this.$data.accPhone = i.phone;
      this.$data.accImage = i.image;
      this.$data.accEmail = i.email;
    },

    uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;
      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("file", data.target.files[0]);
      formdata.append("Accounts", this.$data.accName);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            this.$data.displayImage = response.data.files[0].url;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },

    deleteImage() {
      this.$data.displayImage = "";
      if (this.$refs.fileInput) this.$refs.fileInput.value = null;
    },

    onImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.accImage = file;
        this.displayImage = URL.createObjectURL(file);
      }
    },

    clearImage() {
      this.displayImage = "";
      this.accImage = "";
      if (this.$refs.fileInput) this.$refs.fileInput.value = null;
    },

    triggerFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },

    onDropImage(e) {
      const files = e.dataTransfer.files;
      if (files && files[0]) {
        this.onImageChange({ target: { files } });
      }
    },

    async btnAddAdmin() {
      this.$vs.loading();
      try {
        if (!this.$data.admin.name || !this.$data.admin.email || !this.$data.admin.phone || !this.$data.admin.password) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Account Error",
            text: "Please fill all the required fields.",
            color: "danger",
            position: "top-right",
          });
          return;
        }
        this.$data.admin.image = this.$data.displayImage;

        const r = await api.post(API.ADD_ADMIN, this.$data.admin, { headers });
        if (r.status === 200) {
          this.$vs.notify({
            text: "Account saved",
            color: "success",
            position: "top-right",
          });
          await this.fetchAllAccounts();
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Account save Error",
          text: "An error occurred while adding the admin.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    addingNewItem() {
      this.addAdmin = true;
      this.clearImage();
      this.$data.admin = { type: "ADMIN" };
      this.fetchAllAccounts();
    },

    deletePopup(item) {
      this.deleteAccountPopup = true;
      this.itemToDelete = item;
    },
  },
  async created() {
    this.setAppUser();
    await this.fetchAllAccounts();
  },
};
</script>

<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}

.highlighted-account {
  background-color: #f0f8ff;
  font-weight: bold;
}
</style>
